<template>
  <div class="system-builder__modal" :class="{'out': isActive === false, 'blowup': isActive}">
    <div class="modal-background" @click="{$emit('closeModal')}">
      <div class="modal">
        <slot name="modal-body"></slot>
        <span class="system-builder__modal--close" @click="closeModal">
          <i class="fa fa-times-circle-o" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal',
    props: ['isActive', 'name'],
    data () {
      return {
        modalName: this.name,
        active: this.isActive
      }
    }
  }
</script>



// WEBPACK FOOTER //
// modal.vue?30e3ef34